import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";

/**
 * Filtre statut, plusieurs choix possibles. `selectedStatus` est la liste des
 * statuts séparés par des virgules (« 4,5,3 »), telle que l'API la reçoit dans
 * `status` ; vide = tous les statuts.
 */
const statusOptions = [
  { value: "4", label: "En cours de validation" },
  { value: "5", label: "Validé" },
  { value: "3", label: "En préparation" },
  { value: "1", label: "En cours de livraison" },
  { value: "2", label: "Livré" },
  { value: "6", label: "Annulée" },
];

const CommandeStatusDropdown = ({ selectedStatus, onStatusChange }) => {
  const choisis = String(selectedStatus || "").split(",").filter(Boolean);

  const basculer = (value) => {
    const suivants = choisis.includes(value) ? choisis.filter((v) => v !== value) : [...choisis, value];
    // Dans l'ordre de la liste, pour une valeur stable quel que soit l'ordre des clics.
    onStatusChange(statusOptions.map((o) => o.value).filter((v) => suivants.includes(v)).join(","));
  };

  const libelle =
    choisis.length === 0
      ? "Tous les statuts"
      : choisis.length === 1
        ? statusOptions.find((o) => o.value === choisis[0])?.label
        : `${choisis.length} statuts`;

  return (
    // autoClose « outside » : le menu reste ouvert pour cocher plusieurs statuts.
    <Dropdown autoClose="outside">
      <Dropdown.Toggle variant="outline-secondary" className="bg-body text-body">
        {libelle}
      </Dropdown.Toggle>
      <Dropdown.Menu className="px-3 py-2" style={{ minWidth: 230 }}>
        {statusOptions.map((status) => (
          <Form.Check
            key={status.value}
            type="checkbox"
            id={`statut-${status.value}`}
            label={status.label}
            checked={choisis.includes(status.value)}
            onChange={() => basculer(status.value)}
            className="py-1"
          />
        ))}
        {choisis.length > 0 && (
          <>
            <Dropdown.Divider />
            <Dropdown.Item as="button" className="px-0 small" onClick={() => onStatusChange("")}>
              Tous les statuts
            </Dropdown.Item>
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CommandeStatusDropdown;
